<template>
  <div class="nav">
    <div class="navC">
      <div class="navLogo">
        <router-link to="/">
          <img src="../assets/images/TPE_LOGO.png" alt class="u-maxw-110"/>
        </router-link>
      </div>
      <ul>
        <li>
          <router-link to="/">主頁</router-link>
        </li>
        <li>
          <a @click.prevent="serviceMove">我們的服務</a>
        </li>
        <li>
          <a @click.prevent="goInformation">兌換資訊</a>
        </li>
        <li>
          <a @click.prevent="findMove">聯繫我們</a>
        </li>
        <el-button class="navbtn" size="mini">
          <v-reserve></v-reserve>
        </el-button>
      </ul>
    </div>
  </div>
</template>
<script>
import reserve from "./reserve";
export default {
  data() {
    return {};
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
    serviceMove() {
      this.navigateToSection("service");
    },
    findMove() {
      this.navigateToSection("find");
    },
    goInformation() {
      const targetPath = "/information/";
      if (this.$route && this.$route.path === targetPath) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      this.$router.push({ path: targetPath }).catch(() => {});
    },
    navigateToSection(section) {
      const selector = section === "find" ? ".find" : ".service";
      if (this.$route && this.$route.path === "/") {
        this.$nextTick(() => {
          this.scrollToSection(selector);
        });
        return;
      }
      // 非首页时跳转首页，由首页路由逻辑处理锚点滚动
      this.$router.push({ path: "/", query: { section } }).catch(() => {});
    },
    scrollToSection(selector) {
      const target = document.querySelector(selector);
      if (!target) return;
      const navEl = document.querySelector(".nav");
      const navHeight = navEl ? navEl.getBoundingClientRect().height : 0;
      console.log(navHeight, 'navHeight');
      const top = target.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    },
  },
  components: {
    "v-reserve": reserve
  }
};
</script>
<style lang="scss">
.u-maxw-110 {
  max-width: 110px;
}
@import "../common/font/font.css";
.nav {
  position: fixed;
  top: 0px;
  font-family: Regular;
  width: 100%;
  background: white;
  height: 70px;
  z-index: 9999;
}
.navC {
  width: 70%;
  height: 70px;
  line-height: 70px;
  margin: auto;
}
.navC > div {
  float: left;
  margin-left: 50px;
}
.navC > ul {
  float: right;
  margin-right: 50px;
}
.navC > ul > li {
  display: inline-block;
  padding: 0 20px;
}
.navC > ul > li > a {
  color: black;
  text-decoration: none;
}
.navC > ul > button {
  color: white;
  background: #DFB743;
  border: none;
  border-radius: 10px;
}
.navC > ul > li:hover a {
  color: #DFB743;
  cursor: pointer;
}
.navC > ul > button > span > div > button {
  padding: 0;
  color: white;
}
@media (max-width: 1182px) {
  .navC {
    width: 90%;
  }
}
@media (max-width: 890px) {
  .nav {
    height: 140px;
  }
  .navC {
    width: 95%;
    text-align: center;
    height: auto;
    line-height: 0;
  }
  .navC > ul {
    float: none;
    margin-right: 0px;
  }
  .navC > div {
    margin-left: 0;
    float: none;
  }
  .navC > ul > li {
    padding: 0 2px;
    font-size: 12px;
    box-sizing: border-box;
  }
}
</style>
<style>
.el-button.navbtn.el-button--default.el-button--mini:hover {
  color: white;
  background-color: #DFB743;
}

.el-button.navbtn.el-button--default.el-button--mini:active {
  color: white;
}
</style>
